
import InfoTooltip from "components/InfoTooltip";
import RadioButtons from "components/RadioButtons/RadioButtons";
import React from 'react';
import { OrderFieldsLabels, OrderFieldsLabelsContent, OrderFieldsLabelsContentTitle, OrderFieldsLabelsItem, OrderFieldsLabelsWrapper } from './Theme';

const OrderFieldsMailingLabels = ({
  selectedAddress,
  setSelectedAddress,
  labelSize,
  setLabelSize
}) => {


  return (
    <OrderFieldsLabels>
      <OrderFieldsLabelsWrapper>
        <OrderFieldsLabelsContent>
          <OrderFieldsLabelsItem>
            <OrderFieldsLabelsContentTitle style={{ display: 'flex', alignItems: 'center' }}>
              Address
              <InfoTooltip text="Choose which address on file to print on the labels — the member's active mailing address or their billing address." style={{ marginLeft: '6px' }} />
            </OrderFieldsLabelsContentTitle>
            <RadioButtons
              value={selectedAddress}
              name={"address-labels"}
              onChange={(value) => setSelectedAddress(value)}
              defaultValue={"active-address"}
              size={"small"}
              options={[
                {
                  label: "Active Address",
                  value: "active-address"
                },
                {
                  label: "Billing Address",
                  value: "billing-address"
                }
              ]}
            />
          </OrderFieldsLabelsItem>
          <OrderFieldsLabelsItem>
            <OrderFieldsLabelsContentTitle style={{ display: 'flex', alignItems: 'center' }}>
              Label Sizes
              <InfoTooltip text="Pick the label sheet size so the exported PDF lines up correctly when printed." style={{ marginLeft: '6px' }} />
            </OrderFieldsLabelsContentTitle>
            <RadioButtons
              value={labelSize}
              name={"label-size"}
              onChange={(value) => setLabelSize(value)}
              defaultValue={"avery-5160"}
              size={"small"}
              options={[
                {
                  label: "Avery 5160 - Inches 2⅝ w x 1 h",
                  value: "avery-5160"
                },
              ]}
            />
          </OrderFieldsLabelsItem>
        </OrderFieldsLabelsContent>
      </OrderFieldsLabelsWrapper>
    </OrderFieldsLabels>
  )
}

export default OrderFieldsMailingLabels